module.exports = __webpack_public_path__ + "img/discoverS.64a97e1f.png";